import { IMAGES, WHY_CHOOSE } from "@/data/site";
import { ShieldCheck, BadgeDollarSign, Hammer, Clock, Sparkles, Droplets } from "lucide-react";
import { usePageMeta, SectionLabel, PageHero, CTABanner, PrimaryButton } from "@/components/common";

const ICONS = { ShieldCheck, BadgeDollarSign, Hammer, Clock, Sparkles, Droplets };

export default function About() {
  usePageMeta("About Us", "Learn about A.D.N Stucco Inc — Central Florida's licensed & insured stucco and plastering contractor built on quality craftsmanship and customer satisfaction.");
  return (
    <div data-testid="about-page">
      <PageHero label="About A.D.N Stucco Inc" title="Building Central Florida's finest stucco finishes" subtitle="Years of experience, thousands of square feet of flawless finishes, and a reputation built on honesty and reliability." image={IMAGES.craftsman} />
      <section className="py-24 bg-adn-white">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
          <img src={IMAGES.residential} alt="A.D.N Stucco completed home" className="w-full h-[520px] object-cover" />
          <div>
            <SectionLabel>Our Story</SectionLabel>
            <h2 className="text-4xl font-heading font-extrabold mt-6 leading-tight">Craftsmanship, integrity, and lasting results</h2>
            <p className="text-lg text-zinc-600 mt-6 leading-relaxed">A.D.N Stucco Inc was founded on a simple principle: deliver exceptional stucco and plaster work with honesty and respect for every customer. Over the years we've earned the trust of homeowners, builders, and business owners throughout Central Florida.</p>
            <p className="text-lg text-zinc-600 mt-4 leading-relaxed">Our skilled craftsmen bring meticulous attention to detail to every project — whether it's a new installation, a repair, or a custom finish. We use long-lasting, weather-resistant materials engineered for Florida's demanding climate, and we back our work with reliable communication and clean job sites.</p>
            <div className="mt-10"><PrimaryButton to="/contact" testid="about-cta">Request a Free Estimate</PrimaryButton></div>
          </div>
        </div>
      </section>
      <section className="py-24 bg-adn-off">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 text-center">
            {[["25+", "Years Experience"], ["1k+", "Projects Completed"], ["100%", "Licensed & Insured"], ["5.0", "Customer Rating"]].map(([n, l]) => (
              <div key={l} className="bg-white border border-zinc-200 p-8">
                <div className="text-4xl sm:text-5xl font-heading font-black text-adn-red">{n}</div>
                <div className="label-accent text-zinc-500 mt-2">{l}</div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16">
            {WHY_CHOOSE.map((w) => {
              const Icon = ICONS[w.icon];
              return (
                <div key={w.title} className="bg-white border border-zinc-200 p-8">
                  <div className="w-12 h-12 flex items-center justify-center bg-adn-redlight text-adn-red"><Icon size={24} /></div>
                  <h3 className="text-xl font-heading font-bold mt-6">{w.title}</h3>
                  <p className="text-zinc-600 mt-3 leading-relaxed">{w.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      <CTABanner />
    </div>
  );
}
